var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "form-personal-info rounded-lg -mx-2 px-4 py-2 leading-4 text-base"
  }, [!_vm.editName ? _c('div', {
    staticClass: "flex justify-between cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.editName = true;
      }
    }
  }, [_c('span', {
    staticClass: "truncate"
  }, [_vm._v(_vm._s(_vm.form.first_name) + " " + _vm._s(_vm.form.last_name))]), _vm._v(" "), _c('img', {
    staticClass: "ml-5 w-5",
    attrs: {
      "src": require("assets/images/edit.svg")
    }
  })]) : _c('div', [_c('label', {
    staticClass: "text-sm",
    attrs: {
      "for": "formPersonalInfoFirstName"
    }
  }, [_vm._v("Full Legal Name")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputForm.first_name,
      expression: "inputForm.first_name"
    }],
    class: _vm.formErrors.first_name && 'invalid',
    attrs: {
      "id": "formPersonalInfoFirstName",
      "placeholder": "First name",
      "autocomplete": "given-name",
      "name": "first_name"
    },
    domProps: {
      "value": _vm.inputForm.first_name
    },
    on: {
      "focus": function ($event) {
        return _vm.$emit('onFieldFocus', 'first_name');
      },
      "blur": function ($event) {
        return _vm.$emit('onFieldBlur', 'first_name');
      },
      "keyup": function ($event) {
        return _vm.$emit('onFieldChange', 'first_name');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.inputForm, "first_name", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputForm.last_name,
      expression: "inputForm.last_name"
    }],
    staticClass: "ml-2",
    class: _vm.formErrors.last_name && 'invalid',
    attrs: {
      "id": "formPersonalInfoLastName",
      "placeholder": "Last name",
      "autocomplete": "family-name",
      "name": "last_name"
    },
    domProps: {
      "value": _vm.inputForm.last_name
    },
    on: {
      "focus": function ($event) {
        return _vm.$emit('onFieldFocus', 'last_name');
      },
      "blur": function ($event) {
        return _vm.$emit('onFieldBlur', 'last_name');
      },
      "keyup": function ($event) {
        return _vm.$emit('onFieldChange', 'last_name');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.inputForm, "last_name", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ml-5 w-5 cursor-pointer",
    class: {
      'cursor-not-allowed': _vm.nameDisabled
    },
    attrs: {
      "src": require("assets/images/check-grey.svg")
    },
    on: {
      "click": function ($event) {
        if (!_vm.nameDisabled) _vm.editName = false;
      }
    }
  })])]), _vm._v(" "), !_vm.editEmail ? _c('div', {
    staticClass: "flex justify-between cursor-pointer",
    on: {
      "click": _vm.emailClicked
    }
  }, [_c('form-phone-tooltip', {
    attrs: {
      "trigger": "",
      "force-show": _vm.showEmailTooltip
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function () {
        return [_vm._v("Make sure you entered a correct email address. If you think this is a mistake, please\n\t\t\t\tcontact our "), _c('a', {
          attrs: {
            "target": "blank",
            "href": "mailto:hey@extra.app"
          }
        }, [_vm._v("Extra Concierge")]), _vm._v(".")];
      },
      proxy: true
    }], null, false, 1305857001)
  }, [_c('span', {
    staticClass: "truncate"
  }, [_vm._v(_vm._s(_vm.form.email))])]), _vm._v(" "), _c('img', {
    staticClass: "ml-5 w-5",
    attrs: {
      "src": require("assets/images/edit.svg")
    }
  })], 1) : _c('div', [_c('label', {
    staticClass: "text-sm",
    attrs: {
      "for": "formPersonalInfoEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputForm.email,
      expression: "inputForm.email"
    }],
    class: _vm.formErrors.email && 'invalid',
    attrs: {
      "id": "formPersonalInfoEmail",
      "type": "email",
      "name": "email",
      "placeholder": "Email address",
      "autocomplete": "email"
    },
    domProps: {
      "value": _vm.inputForm.email
    },
    on: {
      "focus": function ($event) {
        return _vm.$emit('onFieldFocus', 'email');
      },
      "blur": function ($event) {
        return _vm.$emit('onFieldBlur', 'email');
      },
      "keyup": function ($event) {
        return _vm.$emit('onFieldChange', 'email');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.inputForm, "email", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ml-5 w-5 cursor-pointer",
    class: {
      'cursor-not-allowed': _vm.emailDisabled
    },
    attrs: {
      "src": require("assets/images/check-grey.svg")
    },
    on: {
      "click": function ($event) {
        if (!_vm.emailDisabled) _vm.editEmail = false;
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('form-phone-tooltip', [_c('span', [_vm._v(_vm._s(_vm._f("VMask")(_vm.form.phone, '###-###-####')))])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };